import {
    Home as HomeIcon,
    TrendingUp as SharedReportsIcon,
    Face as Accounts,
    Tune as Adjustments,
    Receipt,
    CreditCard as Expense,
    Widgets as ProductsIcon,
    Book as AccountingIcon,
    GroupOutlined as Members,
    SettingsApplicationsOutlined as Settings,
    Assessment
} from '@material-ui/icons';

import SyncIcon from '@material-ui/icons/Sync';
import SettingsIcon from '@material-ui/icons/Settings';
import AdminIcon from '@material-ui/icons/SupervisorAccount';
import React from 'react';
import { orgId, getOrg } from './utils/auth';

const isAdjustmentsEnabled = (orgConfig) => {
    if (orgConfig) {
        const adjustments =
            orgConfig.find(cfg => cfg.id == 'properties/manualAdjustmentsEnabled');

        return (adjustments && adjustments.value == true);
    }

    return false;
}

const accountingMenu = props => {
    const toReturn = [
        {
            title: 'Journals',
            icon: <Assessment />,
            getHref: () => `/${orgId()}/journalaccounts`,
            visible: (org) => org ? true : false
        }, {
            title: 'Adjustments',
            icon: <Adjustments />,
            getHref: () => `/${orgId()}/adjustments`,
            visible: (org) => org ? true : false
        }
    ]

    return toReturn;
}

const settingsMenu = props => {
    const toReturn = [
        {
            title: 'Configure RevRec',
            getHref: () => `/${orgId()}/organization/settings?tab=1`,
            visible: (org) => org ? true : false
        },
        {
            title: 'Accounting Rules',
            getHref: () => `/${orgId()}/esp?tab=0`,
            visible: (org) => org ? true : false
        },
        {
            title: 'Team Members',
            getHref: () => `/${orgId()}/organization?tab=0`,
            visible: (org) => org ? true : false
        }, 
    ]

    return toReturn;
}

export const _menuItems = [
    {
        title: 'Home',
        icon: <HomeIcon />,
        getHref: () => `/${orgId()}/dashboards`,
        visible: (org) => orgId().startsWith('7') || orgId().startsWith('6') ? false : org ? true : false
    },

    {
        title: 'Customers',
        icon: <Accounts />,
        getHref: () => `/${orgId()}/pages/customers`,
        visible: (org) => orgId().startsWith('7') || orgId().startsWith('6') ? false : org ? true : false,
    },
    {
        title: 'Sales Order',
        icon: <Receipt />,
        getHref: () => `/${orgId()}/pages/sales`,
        visible: (org) => orgId().startsWith('7') || orgId().startsWith('6') ? false :  org ? true : false,
    },
    {
        title: 'Expense',
        icon: <Expense />,
        getHref: () => `/${orgId()}/pages/expenses`,
        visible: (org, props) => {
            const config = props.orgConfig && props.orgConfig.find(cfg => cfg.id == 'properties/expense-enabled')
            return orgId().startsWith('7') || orgId().startsWith('6') ? false : (org && (config && config.value == true)) ? true : false
        },
    },
    {
        title: 'Products',
        icon: <ProductsIcon />,
        getHref: () => `/${orgId()}/products`,
        visible: (org) => orgId().startsWith('7') || orgId().startsWith('6') ? false : org ? true : false
    },
    {
        title: 'Accounting',
        icon: <AccountingIcon />,
        getHref: () => `/${orgId()}/journalaccounts`,
        visible: (org, props) => orgId().startsWith('7') || orgId().startsWith('6') ? false : org && !isAdjustmentsEnabled(props.orgConfig) ? true : false,
    },
    {
        title: 'Accounting',
        icon: <AccountingIcon />,
        visible: (org, props) => orgId().startsWith('7') || orgId().startsWith('6') ? false : org && isAdjustmentsEnabled(props.orgConfig) ? true : false,
        createChildren: accountingMenu
    },
    {
        title: 'Sync',
        icon: <SyncIcon />,
        getHref: () => `/${orgId()}/pages/sync`,
        visible: (org) => orgId().startsWith('7') || orgId().startsWith('6') ? false : org ? true : false
    },
    {
        title: 'Reports',
        icon: <SharedReportsIcon />,
        getHref: () => `/${orgId()}/mstr-native-report-parent`,
        visible: (org, props) => {
            if (org && !org.disableReporting) {
                return true;
            }

            return !org.disableReporting;
        }
    },
    {
        title: 'Settings',
        icon: <SettingsIcon />,
        visible: (org, props) => orgId().startsWith('7') || orgId().startsWith('6') ? false : org ? ((props && props.clientTables && props.clientTables.length > 0) ? false : true) : false,
        createChildren: settingsMenu
    },
    {
        title: 'Admin',
        getHref: () => `/admin`,
        icon: <AdminIcon />,
        visible: (org, props) => {
            const { currentUser } = props;
            return currentUser && (currentUser.superAdminLevel > 0);
        },

    }
];

export const getMenuItems = (menuItems = _menuItems, props = {}) => {
    return menuItems.map(item => {
        if (item.visible(getOrg(), props)) {
            item.href = item.getHref && item.getHref()

            if (item.children) {
                item.children = item.children && getMenuItems(item.children, props);
            } else if (item.createChildren) {
                item.children = getMenuItems(item.createChildren(props), props);
            }
        }

        return item;
    })
}

export const routeItems = [
    {
        title: 'Profile',
        href: '/profile'
    }, {
        title: 'Dashboard',
        href: '/dashboards'
    }
]
